import * as React from "react";
import Avatar from "@mui/material/Avatar";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import Divider from "@mui/material/Divider";
import Settings from "@mui/icons-material/Settings";
import Logout from "@mui/icons-material/Logout";
import { User } from "../Interface/IUser";
import { useNavigate } from "react-router-dom";
import userIcon from "../images/person_icon.png";

export default function AccountMenu() {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const navigate = useNavigate();

  const [userInfo, setUserInfo] = React.useState<User>({
    id: 0,
    username: "",
    firstName: "",
    lastName: "",
    phoneNumber: "",
    password: "",
    email: "",
    createdBy: "",
    isActive: true,
    isMDMActive:false,
    roleID: "",
    userType: "",
    token: "",
    passwordResetRequired: false,
    passwordResetAlertMessage: "",
    mdmAccesses:[],
  });

  const useEffectCount = React.useRef(true);
  React.useEffect(() => {
    if (useEffectCount.current) {
      useEffectCount.current = false;

      if (localStorage.getItem("user-info-lpa") !== null) {
        var currentUser = JSON.parse(
          localStorage.getItem("user-info-lpa") || " "
        );
        if (currentUser !== " ") {
          setUserInfo(currentUser);
        }
      }
    }
  }, []);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleCloseMenu = (link: string) => {
    debugger;
    if (link === "Logout") {
      localStorage.removeItem("user-info-lpa");
      localStorage.removeItem("mdmAccessesdata");
      window.location.href = "/";
    } else {
      navigate(link);
    }
    setAnchorEl(null);
  };

  return (
    <>
      {userInfo.id === 0 ? (
        <></>
      ) : (
        <div>
          {" "}
          {(userInfo.passwordResetAlertMessage || "") != "" && (
            <p className="pws-expires">
              <>
                {userInfo.passwordResetAlertMessage}
                <a href="/ResetPassword">Click here to change it.</a>
              </>
            </p>
          )}
          <p className="user-name">
            Hello {userInfo.firstName} {userInfo.lastName}
          </p>
          <img
            src={userIcon}
            className="user-icon"
            id="basic-button"
            aria-controls={open ? "basic-menu" : undefined}
            aria-haspopup="true"
            aria-expanded={open ? "true" : undefined}
            onClick={handleClick}
          />{" "}
          <Menu
            anchorEl={anchorEl}
            id="account-menu"
            open={open}
            onClose={handleClose}
            onClick={handleClose}
            PaperProps={{
              elevation: 0,
              sx: {
                borderRadius: 0,
                overflow: "visible",
                filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                mt: 1.5,
                "& .MuiAvatar-root": {
                  width: 32,
                  height: 32,
                  ml: -0.5,
                  mr: 1,
                },
                "&:before": {
                  content: '""',
                  display: "block",
                  position: "absolute",
                  top: 0,
                  right: 14,
                  width: 10,
                  height: 10,
                  bgcolor: "background.paper",
                  transform: "translateY(-50%) rotate(45deg)",
                  zIndex: 0,
                },
              },
            }}
            transformOrigin={{ horizontal: "right", vertical: "top" }}
            anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
          >
            {/* <MenuItem>
              <Avatar /> Profile
            </MenuItem> */}
             {(userInfo.userType == "Admin")? (
              <>
            <MenuItem onClick={() => handleCloseMenu("Services")}>
              <Avatar /> Home
            </MenuItem>
            <Divider />
            </>
            ) : (
              <></>
            )} 
            {/*{userInfo.userType == "Admin" || userInfo.userType == "Super Admin"? (*/}
            {/*  <>*/}
            {/*    <MenuItem onClick={() => handleCloseMenu("UserList")}>*/}
            {/*      <ListItemIcon>*/}
            {/*        <PersonAdd fontSize="small" />*/}
            {/*      </ListItemIcon>*/}
            {/*      Manage Users*/}
            {/*    </MenuItem>*/}
            {/*    </>*/}
            {/*) : (*/}
            {/*  <></>*/}
            {/*)} */}
            {/* {userInfo.userType == "Super Admin"? (*/}
            {/*  <>*/}
            {/*    <MenuItem onClick={() => handleCloseMenu("ServicesList")}>*/}
            {/*      <ListItemIcon>*/}
            {/*        <Settings fontSize="small" />*/}
            {/*      </ListItemIcon>*/}
            {/*      Manage Services*/}
            {/*    </MenuItem>*/}
            {/*    </>*/}
            {/*) : (*/}
            {/*  <></>*/}
            {/*)} */}
            {/*    {userInfo.userType == "Admin" || userInfo.userType == "Super Admin"? (*/}
            {/*  <>*/}
            {/*    <MenuItem onClick={() => handleCloseMenu("RoleList")}>*/}
            {/*      <ListItemIcon>*/}
            {/*        <DisplaySettingsIcon fontSize="small" />*/}
            {/*      </ListItemIcon>*/}
            {/*      Manage Roles*/}
            {/*    </MenuItem>*/}
            {/*    </>*/}
            {/*) : (*/}
            {/*  <></>*/}
            {/*)} */}
            {userInfo.userType == "External User" ? (
              <MenuItem onClick={() => handleCloseMenu("ResetPassword")}>
                <ListItemIcon>
                  <Settings fontSize="small" />
                </ListItemIcon>
                Reset Password
              </MenuItem>
            ) : (
              <></>
            )}

            <MenuItem onClick={() => handleCloseMenu("Logout")}>
              <ListItemIcon>
                <Logout fontSize="small" />
              </ListItemIcon>
              Logout
            </MenuItem>
          </Menu>
        </div>
      )}
    </>
  );
}
